module.exports = __webpack_public_path__ + "media/399934__waveplay__short-click-snap-perc.24316567.mp4";